import { Component, OnInit, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { McqService } from '../../service/mcq.service';
import { TestSeriesService } from '../../service/test-series.service';
import { Globals } from '../../globals';
import { HttpErrorResponse } from '@angular/common/http';
import { commonService } from "../../service/common.service";
import { Http, ResponseContentType } from '@angular/http';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'app-dailyquiz',
  templateUrl: './dailyquiz.component.html',
  styleUrls: ['./dailyquiz.component.css'],
  providers: [McqService, TestSeriesService],
  animations: [
    trigger('scrollAnimation', [
      state('show', style({
        opacity: 1,
        transform: "translateX(0)"
      })),
      state('hide', style({
        opacity: 0,
        transform: "translateX(-100%)"
      })),
      transition('show => hide', animate('700ms ease-out')),
      transition('hide => show', animate('700ms ease-in'))
    ])
  ]
})

export class DailyquizComponent implements OnInit {
  typetxt: any = '';
  packageList: any = [];
  isPostLoad: any = true;
  msg: any = '';
  isRemaningForum: any;
  postId: any = 0;
  ngload: any;
  filter: any;
  noMoreResults: any;
  isError = false;
  siteUrl = this.global.websiteUrl;
  userId = 0;
  child: any;
  windowCloseType: any;
  windowCloseId: any;
  streambox: any;
  streamText: any;
  userDatalogincheck: any;
  quizUrl: boolean = false;
  currenttodaydate: any;

  constructor(private http: Http, private mcqservice: McqService, private router: Router, private route: ActivatedRoute, private global: Globals, private commonService: commonService, private testseriesservice: TestSeriesService) {

    this.commonService.profile.subscribe((data: any) => {

      if (data) {
        this.userDatalogincheck = data;
      } else {
        this.userDatalogincheck = {};
      }

    });

    this.ngload = true;
    this.isRemaningForum = true; // for load more
    this.isPostLoad = false; // for load more
    this.packageList = [];

  }

  ngOnInit() {
    var todaydate = new Date().toJSON();
    this.currenttodaydate = new Date().toJSON();
    this.route.params.subscribe((params: Params) => {
      if (params['id']) {
        this.isPostLoad = true;
        this.postId = parseInt(params['id']);

        if (isNaN(this.postId)) {
          this.postId = 0;
        }
        // console.log('ddddddddddddddddddddd');
        if (this.postId > 0) {
          this.typetxt = this.postId;
          this.packageList = [];
          let filter = {};
          filter = { limit: 10 };
          this.getStudentQuizList(filter);
          this.ngload = true;
        }
      }
    });


    this.getStreamList('');
    let filter = {};
    filter = { limit: 10 };
    this.packageList = [];
    if (this.postId == 0) this.getStudentQuizList(filter);
    this.ngload = true;
  }

  /***************** LISTING *********************** */
  getStudentQuizList(obj) {
    obj['offset'] = this.packageList.length ? this.packageList.length : 0;
    obj['studentId'] = (this.userDatalogincheck) ? this.userDatalogincheck.id : 0;
    obj['streamId'] = this.typetxt;
    obj['published'] = 1;
    obj['status'] = 'Active';
    this.isPostLoad = true;  // for load more
    this.mcqservice.getStudentQuizList(obj).subscribe((data: any) => {
      let finaldata = [];
      if (data.error == 0) {
        if (data.results.rows.length > 0) {
          Array.prototype.push.apply(this.packageList, data.results.rows);
          //console.log('gg',this.packageList);
          this.isPostLoad = false;
        } else {
          this.isRemaningForum = false;
          this.isPostLoad = false;
          this.noMoreResults = true;
          //console.log('cccccc',this.noMoreResults);
        }

      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    }, (error: HttpErrorResponse) => {
      this.isPostLoad = false;
      this.msg = "internal server error!";
    });
  }

  reportUrl(tpid) {
    return '../overallreport/' + btoa(tpid);
  }

  loadmorePackage() {
    //console.log('loadmoreForum');
    this.getStudentQuizList({ limit: 10, isnewList: true });
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    var scrollPosition = $(window).scrollTop() + $(window).height();
    var pageheight = $(document).height() - $('#footer-section').outerHeight();
    if (scrollPosition >= pageheight && this.isRemaningForum == true && this.isPostLoad != true) {
      this.isPostLoad = true;
      this.loadmorePackage();
    }
  }
  /*************** END ************** */
  needLogin() {
    this.commonService.setLoginBox(true);
  }

  OpenQuestionWindow(id) {

    if (Object.keys(this.userDatalogincheck).length == 0) {
      this.needLogin();
      return false;
    }
    if (this.quizUrl) {
      alert("Quiz is already running in a new window.");
      return;
    }
    //this.router.navigate(['/']);
    var randomnumber = Math.floor((Math.random() * 100) + 1);
    var child = window.open('/onlineMCQ/online/instruction/' + btoa(id), "_blank", 'PopUp' + randomnumber + ',scrollbars=1,menubar=0,resizable=1,width=1300,height=650');
    this.quizUrl = true;
    //console.log(this.child);
    var winClosed = setInterval(function (this) {
      if (child.closed) {
        this.quizUrl = false;
        clearInterval(winClosed);
        //alert('closed');  

        setTimeout(() => {
          document.getElementById("closeChildWindow").click();
          this.quizUrl = false;
        }, 1000);
      }
    }, 1000);
    //console.log(this.quizUrl);
  }

  // openReportUrl(id){
  //   if(this.postId) return '../../quiz/overallreport/'+btoa(id);
  //   else return '../quiz/overallreport/'+btoa(id);
  // }

  // // ON CLOSE OF QUIZ WINDOW REDIRECT TO DIFFRENT PAGE
  // closewindow(){
  //   this.quizUrl = false;
  //   var idtype:any = document.getElementById("parentWindowType");
  //   this.windowCloseType = idtype.value;

  //   if(idtype.value=='1'){
  //     var windowId:any = document.getElementById("parentWindowId");
  //     this.windowCloseId = windowId.value;
  //   }
  // }

  openReportUrl(id) {
    if (this.postId) return '../../user/overallreport/' + btoa(id);
    else return '../user/overallreport/' + btoa(id);
  }

  // ON CLOSE OF QUIZ WINDOW REDIRECT TO DIFFRENT PAGE
  closewindow() {
    this.quizUrl = false;
    var idtype: any = document.getElementById("parentWindowType");
    this.windowCloseType = idtype.value;

    if (idtype.value == '1') {
      var windowId: any = document.getElementById("parentWindowId");
      this.windowCloseId = windowId.value;
    }

    if (this.windowCloseType == '1') {
      this.router.navigateByUrl('/user/overallreport/' + this.windowCloseId);
    } else if (this.windowCloseType == '2') {
      this.router.navigateByUrl('/user/dailyquizreport');
    } else {
      let filter = {};
      filter = { limit: 10 };
      this.getStudentQuizList(filter);
    }
  }


  // STREAM LISTING AND FILTERS
  getStreamList(streamId) { //streamlist
    this.mcqservice.getteststreams(streamId).subscribe((data: any) => {
      if (data.error == 0) {
        // console.log('stream',data);
        this.streambox = data.results;
        this.streambox.unshift({ id: '', 'shortName': 'All' });
        this.getstreamText();
      } else {
        if (data.message == "Failed to authenticate token.") {
          sessionStorage.clear();
          localStorage.clear();
          this.router.navigate(['/']);
        } else {
          this.msg = data.message;
          this.isError = true;
        }
      }
    },
      (error: HttpErrorResponse) => {
        this.isError = true;
        this.msg = "internal server error!";
      });

  }

  filterform(searchtxt) {
    this.ngload = true;
    var Stype = searchtxt.value.Stype.trim();
    this.typetxt = Stype;
    let filter = {};
    filter = { limit: 1000 };
    this.packageList = [];
    this.getStudentQuizList(filter);
  }

  getstreamText() {
    if (this.streambox) {
      for (let st of this.streambox) {
        if (st.id == this.postId) {
          this.streamText = (st.detail) ? st.detail : '';
          continue;
        }
      }
    }

  }

  streamUrl() {
    if (this.postId) return "../../";
    else return "/";
  }

}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/online-mcq/dailyquiz/dailyquiz.component.ts